export const es = {
  commons: {
    accept: 'Aceptar',
    cancel: 'Cancelar',
    close: 'Cerrar',
    delete: 'Borrar',
    refuse: 'Rechazar',
    search: 'Buscar',
  },
  errors: {
    getKeyIndicators:
      'Se ha producido un error al recuperar la información. Vuelva a intentarlo más tarde.',
  },
  dashboard: {
    title: 'Bienvenido a mylight150 Pro',
    keyIndicators: {
      title: 'Sus indicadores clave',
      lastUpdatedHours:
        'Última actualización: hace menos de una hora | Última actualización: hace {count} hora | Última actualización: hace {count} horas',
      lastUpdatedDays:
        'Última actualización : hace 0 días | Última actualización : hace {count} día | Última actualización : hace {count} días',
      totalInstallations: {
        title: 'Instalación | Instalación | Instalaciones',
        description: 'desde principios de año',
        subText:
          'Total : {number} instalación | Total : {number} instalación | Total : {number} instalaciones',
      },
      failingInstallations: {
        title: '%',
        description: 'de instalaciones defectuosas',
        subText: 'Media mylight150 : < {number}%',
      },
      activationRange: {
        title: 'Día | Día | Días',
        description: 'tiempo medio de activación',
        subText:
          'Media mylight150 : < {number} Día | Media mylight150 : < {number} Día | Media mylight150 : < {number} Días',
      },
      equipmentsInstalled: {
        title: 'Equipamiento | Equipamiento | Equipamientos',
        description: 'instalado de media | instalado de media | instalados de media',
        subText: 'Media mylight150 : > {number}',
      },
    },
    usefulLinks: {
      title: 'Recursos útiles',
      newThings: 'Inscríbete en un curso de formación',
      suggestEnhancement: 'Sugerir una mejora',
      helpDesk: 'Centro de ayuda del instalador',
    },
  },
  explanationsModal: {
    subtitleOne: '¿Por qué es importante?',
    subtitleTwo: '¿Cómo resolverlo?',
    failures: {
      title: 'Instalaciones defectuosas',
      description:
        'Este indicador mide la proporción de su parque de instalaciones que presenta anomalías de medición, control o pérdidas de comunicación.',
      paragraphOne:
        'Una instalación defectuosa impide al cliente realizar un seguimiento de su producción en tiempo real. Esto bloquea el control inteligente de los equipos y el fondo común, y puede falsear la facturación de la batería virtual, generando insatisfacción.',
      paragraphTwo: `En la pestaña «Instalación», puede filtrar las instalaciones defectuosas. A continuación, en cada instalación marcada como «defectuosa», encontrará las anomalías detectadas y un enlace a un artículo de preguntas frecuentes que explica cómo resolverlas.`,
    },
    activationDeadline: {
      title: 'Tiempo medio de activación',
      description:
        'Se trata del número medio de días entre la puesta en servicio del equipo y la puesta en servicio efectiva de la batería virtual del cliente.',
      paragraphOne:
        'Mientras la activación no se haya completado, el cliente no podrá beneficiarse del ahorro de batería virtual. Un plazo breve refuerza la imagen de capacidad de respuesta de su empresa y la satisfacción de sus clientes.',
      paragraphTwo: `Anticípese a la recopilación de documentos administrativos y asegúrese de enviarlos lo antes posible.`,
    },
    averageEquipmentsInstalled: {
      title: 'Equipos instalados de media',
      description:
        'Este indicador realiza un seguimiento del número medio de dispositivos (calentadores de agua, estaciones de recarga, bombas de calor) controlados por MySmartPilot en las instalaciones de sus clientes.',
      paragraphOne:
        'Cuantos más equipos estén conectados y controlados, más ahorrará el cliente en su aplicación. Esto justifica plenamente el valor añadido de su servicio técnico y mejora la rentabilidad de la instalación para su cliente.',
      paragraphTwo: `Durante la fase de asesoramiento, proponga sistemáticamente la conexión de los grandes consumidores, sugiera la caja adecuada para cada situación y compruebe durante la instalación que se han configurado todos los relés de control disponibles.`,
    },
  },
};
